/**
 * Store the given key value in the localstorage, and catch the error if the localStorage is not available
 * @param {String} key
 * @param {Any} value
 */
export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch (err) {
    return
  }
}

/**
 * Get Specific key from localstorage
 * @param {String} key
 * @param {Any} defaultValue
 * @returns {Any} localstorage value
 */
export const getItem = (key, defaultValue = null) => {
  try {
    return localStorage.getItem(key)
  } catch (err) {
    return defaultValue
  }
}

/**
 * Removes specific key from localstorage
 * @param {String} key
 */
export const removeItem = key => {
  try {
    localStorage.removeItem(key)
  } catch (err) {
    return
  }
}

/**
 * Clears the localStorage
 */
export const clear = () => {
  try {
    localStorage.clear()
  } catch (err) {
    return
  }
}
